<template>
  <div class="page-header-about"><a :href="aboutUrl">About</a></div>
</template>
<script>
export default {
  props: ['aboutUrl'],
};
</script>
<style></style>
